import React from 'react';
import LoanHistoryList from '../../component/LoanHistoryList';
import MobileNav from '../../component/MobileNav';
import { useSelector } from 'react-redux';
import VerifiedIcon from '@mui/icons-material/Verified';

export default function LoanHistory() {
    const customerDetails = useSelector(
        (state) => state?.customerJourneyDetails?.customerDetails
    );

    const styles = {
        page: {
            background: '#f5f7fb',
            minHeight: '100vh',
            padding: '20px 10px',
        },
        headerCard: {
            background: '#0f1c2e',
            color: '#fff',
            borderRadius: '14px',
            padding: '18px',
            boxShadow: '0 8px 25px rgba(0,0,0,0.06)',
        },
        badge: {
            background: '#ff7a00',
            color: '#fff',
            padding: '4px 10px',
            borderRadius: '20px',
            fontSize: '12px',
            display: 'inline-flex',
            alignItems: 'center',
            gap: 4,
        },
        avatarWrap: {
            width: 55,
            height: 55,
            borderRadius: '50%',
            background: '#fff',
            overflow: 'hidden',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        },
        sectionCard: {
            background: '#fff',
            borderRadius: '14px',
            boxShadow: '0 8px 25px rgba(0,0,0,0.06)',
            padding: '15px',
            marginTop: '15px',
        },
    };

    return (
        <>
            <div style={styles.page}>
                <div className="container" style={{marginTop:"90px"}}>

                    {/* HEADER */}
                    <div style={styles.headerCard} className="mb-3">

                        <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-3">

                            {/* LEFT */}
                            <div className="d-flex align-items-center gap-3">

                                <div style={styles.avatarWrap}>
                                    {customerDetails?.profile_pic ? (
                                        <img
                                            src={customerDetails.profile_pic}
                                            alt="profile"
                                            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                        />
                                    ) : (
                                        <span style={{ color: '#0f1c2e' }}>👤</span>
                                    )}
                                </div>

                                <div>
                                    <h5 className="mb-0">
                                        Welcome <b>{customerDetails?.full_name}</b>
                                    </h5>

                                    <div className="mt-1">
                                        <span style={styles.badge}>
                                            Verified <VerifiedIcon style={{ fontSize: 16 }} />
                                        </span>
                                    </div>
                                </div>
                            </div>

                            {/* RIGHT */}
                            <div className="text-md-end">
                                <div className="small opacity-75">Loan History</div>
                                <div style={{ color: '#ff7a00', fontWeight: 700 }}>
                                    Your Loan Timeline
                                </div>
                            </div>

                        </div>
                    </div>

                    {/* LOAN HISTORY SECTION */}
                    <div style={styles.sectionCard}>
                        <div className="d-flex justify-content-between align-items-center mb-2">
                            <h6 className="mb-0" style={{ color: '#0f1c2e' }}>
                                Loan History
                            </h6>
                            <span style={{ fontSize: 12, color: '#ff7a00' }}>
                                Recent Activity
                            </span>
                        </div>

                        <LoanHistoryList />
                    </div>

                </div>
            </div>

            <MobileNav />
        </>
    );
}